import { Dispatch } from "redux";

import { API } from "../api/category-api";
import CATEGORIES_CONSTANTS from "../constants/category-constants";
import * as types from '../types/category-types';

//---------------------------------- FETCH ACTIVE CATEGORIES FOR CATALOG --------------------------------------------------
const getCategoriesBegin = (): types.IGetCategoriesBegin => {
    return {
        type: CATEGORIES_CONSTANTS.GET_CATEGORIES_BEGIN
    };
}

const getCategoriesError = (e: any): types.IGetCategoriesError => {
    return {
        type: CATEGORIES_CONSTANTS.GET_CATEGORIES_ERROR,
        error: e
    };
}

const getCategoriesSuccess = (data: any): types.IGetCategoriesSuccess => {
    return {
        type: CATEGORIES_CONSTANTS.GET_CATEGORIES_SUCCESS,
        data
    };
}

export const getCategories = () => {
    return (dispatch: Dispatch) => {
        dispatch(getCategoriesBegin());
        API.getActiveCategories()
        .then((response: any) => {
            dispatch(getCategoriesSuccess(response.data));
        }).catch((error: any) => {
            dispatch(getCategoriesError(error.response));
        });
    }
}

//-------------------- SAVE CATEGORY FILTER IN REDUCER -------
const saveCategoryFilterAction = (categoryFilter: string[]): types.ISaveCategoryFilter => {
    return {
        type: CATEGORIES_CONSTANTS.SAVE_CATEGORY_FILTER,
        data: categoryFilter
    }
}

export const saveCategoryFilter = (categoryFilter: string[]) => {
    return (dispatch: Dispatch) => {
        dispatch(saveCategoryFilterAction(categoryFilter));
    }
}